import React from 'react'

import PropTypes from 'prop-types'

import { Product } from '../Product'

import css from './ProductList.css'

const propTypes = {
  canEditOrder: PropTypes.bool.isRequired,
  products: PropTypes.shape({
    id: PropTypes.string,
  }),
  ageVerified: PropTypes.bool,
  isLimitReached: PropTypes.func.isRequired,
  showCategoryTags: PropTypes.bool,
  toggleAgeVerificationPopUp: PropTypes.func.isRequired,
  numberOfColumnClass: PropTypes.string,
  trackingCategory: PropTypes.string.isRequired,
  isProductDetailRefreshEnabled: PropTypes.bool,
}

const defaultProps = {
  products: null,
  numberOfColumnClass: '',
  ageVerified: false,
  showCategoryTags: false,
  isProductDetailRefreshEnabled: false,
}

const ProductListPresentation = ({
  canEditOrder,
  products,
  ageVerified,
  isLimitReached,
  showCategoryTags,
  toggleAgeVerificationPopUp,
  numberOfColumnClass,
  trackingCategory,
  isProductDetailRefreshEnabled,
}) => (
  <div className={css.productList}>
    {Object.keys(products).map((productKey) => {
      const productProps = products[productKey]
      const limitReached = isLimitReached(productProps)

      return (
        <Product
          key={productProps.id}
          canEditOrder={canEditOrder}
          product={productProps}
          limitReached={limitReached}
          ageVerified={ageVerified}
          numberOfColumnClass={numberOfColumnClass}
          showCategoryTags={showCategoryTags}
          toggleAgeVerificationPopUp={toggleAgeVerificationPopUp}
          category={trackingCategory}
          isProductDetailRefreshEnabled={isProductDetailRefreshEnabled}
        />
      )
    })}
  </div>
)

ProductListPresentation.propTypes = propTypes

ProductListPresentation.defaultProps = defaultProps

export { ProductListPresentation }
